export enum ID {
  SA_ID = "South African ID",
  PASSPORT = "Passport",
}

export interface UserModel {
  full_name: string;
  id_type: number;
  id_number: string;
  email: string;
  mobile_number: string;
  is_verified: boolean;
}

export interface AuthModel {
  user: UserModel | null;
  token: string | null;
  refreshToken: string | null;
  loading?: boolean;
}
